/* eslint-disable */
$(document).ready(function() {
  //Disable submit button
  // $('#gform_submit_button_1').prop('disabled', true);

  function validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  function validateEmpty(input) {
    if (input === '') {
      return false;
    } else {
      return true;
    }
  }

  function validatePositive(input) {
    input = parseInt(input);

    if (input > 0) {
      return true;
    } else {
      false;
    }
  }

  let allFields = [
    {
      element: $('#input_1_1'), //first name field,
      message: 'test message',
      tests: ['empty'],
      passed: false,
      required: true,
      defaultValue: false,
    },
    {
      element: $('#input_1_2'), //last name field,
      message: 'test mess',
      tests: ['empty'],
      passed: false,
      required: true,
      defaultValue: false,
    },
    {
      element: $('#input_1_3'), // email field,
      message: 'test mess',
      tests: ['email', 'empty'],
      passed: false,
      required: true,
      defaultValue: false,
    },
  ];

  const validationTests = {
    empty: function(input) {
      return validateEmpty(input);
    },
    email: function(input) {
      return validateEmail(input);
    },
    positive: function(input) {
      return validatePositive(input);
    },
  };

  allFields.forEach(
    (
      { element, message, tests, passed, required, defaultValue },
      fieldIndex
    ) => {
      let testMethod;
      let passedTests = [];

      //init passedTests to false
      tests.forEach((test, i) => {
        passedTests[i] = false;
      });

      function runTestsAndValidate() {
        let result = false;
        tests.forEach((test, i) => {
          testMethod = validationTests[test];
          result = testMethod(element.val());

          if (result) {
            passedTests[i] = true;
          } else {
            passedTests[i] = false;
          }

          //function to see if every value in passedTests is true
          const isTrue = passedTest => passedTest === true;
          const validatedField = passedTests.every(isTrue);

          //All input tests passed for the individual field
          if (validatedField) {
            allFields[fieldIndex].passed = true;
            element.addClass('valid');
            // if (element.is('input') && element.attr('id') != 'input_2_1') {
            //   element.after(
            //     '<img class="valid" src="https://dev-dry-fertilizer-enhancement-microsite.pantheonsite.io/wp-content/uploads/2020/08/check.svg" />'
            //   );
            // }
            allFieldsPassed();
          } else {
            allFields[fieldIndex].passed = false;
            element.removeClass('valid');
            element.siblings('img').removeClass('valid');
            allFieldsPassed();
          }
        });
      }

      element.on('input', function() {
        runTestsAndValidate();
      });

      if (defaultValue) {
        runTestsAndValidate();
      }
    }
  );

  // $("#input_2_1").on("input", function() {
  //   updateAmountOfEmailFieldsDisplayed();
  // });
  //
  // $(".plus").click(function() {
  //   let value = parseInt($("#input_2_1").val());
  //   value += 1;
  //
  //   if (value <= 100) {
  //     $("#input_2_1").val(value);
  //     updateAmountOfEmailFieldsDisplayed();
  //   }
  // });
  // $(".minus").click(function() {
  //   let value = parseInt($("#input_2_1").val());
  //   value -= 1;
  //
  //   if (value > 0) {
  //     $("#input_2_1").val(value);
  //     updateAmountOfEmailFieldsDisplayed();
  //   }
  // });

  // function hideNonRequiredEmailMobileInit(){
  //   const nonRequiredFields = [
  //     $("#input_2_4"),
  //     $("#input_2_3"),
  //     $("#input_2_2")
  //   ];
  // }

  // updateAmountOfEmailFieldsDisplayed();

  // if ($(window).width() < 1024) {
  //
  //
  // }

  // function updateAmountOfEmailFieldsDisplayed() {
  //   let fieldsCount = parseInt($("#input_2_1").val());
  //
  //   if (!fieldsCount) {
  //     fieldsCount = 1;
  //   }
  //
  //   const availableFields = [
  //     $("#input_2_5"),
  //     $("#input_2_4"),
  //     $("#input_2_3"),
  //     $("#input_2_2")
  //   ];
  //
  //   let fieldsToShow = [];
  //   let fieldsToHide = [];
  //   let index = fieldsCount;
  //   if (fieldsCount > 0 && fieldsCount <= 4) {
  //     fieldsToShow = availableFields.slice(0, index);
  //     fieldsToHide = availableFields.slice(index);
  //   } else {
  //     fieldsToShow = availableFields;
  //     fieldsToHide = [];
  //   }
  //
  //   // debugger
  //
  //   fieldsToShow.forEach((field, i) => {
  //     field.show();
  //     field.closest('li').css('marginBottom', '16px')
  //   });
  //   fieldsToHide.forEach((field, i) => {
  //     field.hide();
  //     field.closest('li').css('marginBottom', '0px')
  //
  //   });
  // }

  //Test to see if every field in required field has passed
  // and if non-required fields are valid
  function allFieldsPassed() {
    const isRequired = field => {
      return field['required'] === true;
    };

    const isTrue = field => {
      return field['passed'] === true;
    };

    const hasValidInput = field => {
      return field['passed'] === true;
    };

    const hasInput = field => {
      const element = field['element'];
      const input = element.val();

      return validateEmpty(input) === true;
    };

    const isEmail = field => {
      const tests = field['tests'];

      return tests.indexOf('email') >= 0;
    };

    const requiredFields = allFields.filter(isRequired);
    const allFieldsWithInputValid = allFields.filter(hasValidInput);
    const allFieldsWithInput = allFields.filter(hasInput);

    // const validEmailCount = allFieldsWithInputValid.filter(isEmail).length;

    // console.log('validEmail', validEmailCount);
    //
    // if (validEmailCount == 0) {
    //   $("#input_2_1").val('1');
    // } else {
    //   $("#input_2_1").val(validEmailCount);
    // }

    // debugger

    // debugger

    const result =
      requiredFields.every(isTrue) &&
      allFieldsWithInputValid.length === allFieldsWithInput.length;

    if (result) {
      $('#gform_submit_button_1').prop('disabled', false);
    } else {
      $('#gform_submit_button_1').prop('disabled', true);
    }
  }
});



// WEBPACK FOOTER //
// ./scripts/util/form-validation.js